module.exports = __webpack_public_path__ + "static/img/05.ce3e366.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/05.png
// module id = YP9B
// module chunks = 1